module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/mainvisual-date-pc-buyback_57366be032ee298de53de140558cc2f9.png";